export const STATUS_OPTIONS = [
  { label: 'invited', value: 'Приглашен' },
  { label: 'participates', value: 'Участвует' },
];
